var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 42.1875L12.5625 36.1875L5.8125 34.6875L6.46875 27.75L1.875 22.5L6.46875 17.25L5.8125 10.3125L12.5625 8.8125L16.125 2.8125L22.5 5.53125L28.875 2.8125L32.4375 8.8125L39.1875 10.3125L38.5312 17.25L43.125 22.5L38.5312 27.75L39.1875 34.6875L32.4375 36.1875L28.875 42.1875L22.5 39.4688L16.125 42.1875ZM20.5312 29.1562L31.125 18.5625L28.5 15.8438L20.5312 23.8125L16.5 19.875L13.875 22.5L20.5312 29.1562Z",
    fill: "#25808C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsVerified);
export default __webpack_public_path__ + "static/media/material-symbols_verified.5b3608bd482bfae34e4444321268afdc.svg";
export { ForwardRef as ReactComponent };